/*******************************************************************************
 * Copyright (c) 2024 Passport Fintech Inc. All Rights Reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 ******************************************************************************/

export interface BulkImportResponse {
  recordsReceived: number;
  recordsProcessed: number;
  fileError: boolean;
  errors: any;
}

export interface BulkImportApiResponse {
  records_received: number;
  records_processed: number;
  file_error: boolean;
  errors: any;
}

/**
 * This method transforms the bulkImportApiResponse into our own
 * Address object which our application understands
 * @param bulkImportApiResponse - the API response
 * @returns - the deserialized BulkImportResponse
 */
export const bulkImportFromApiResponse = (
  bulkImportApiResponse: BulkImportApiResponse
): BulkImportResponse => {
  return {
    recordsReceived: bulkImportApiResponse.records_received,
    recordsProcessed: bulkImportApiResponse.records_processed,
    fileError: bulkImportApiResponse.file_error,
    errors: bulkImportApiResponse.errors,
  };
};

/**
 * constant to hold the keys of local storage for bulk import
 */
export const BULK_IMPORT_STORAGE_KEYS = {
  hideBulkModal: 'hideBulkModal',
};
